import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Receiving, ReceivingPlan } from 'services/action';

import { Page, Button } from 'ui/components';
import { InformationPlan } from './component/section';
import { FormInput, FormItems } from './component/form';
import _ from 'underscore';

const initialState = {
  isLoading: true,
  plan: null,
  form: null,
  items: []
};

const CreateScreen = ({ location }) => {
  const History = useHistory();
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state?.Form);

  const [{ form, items, plan, isLoading }, setState] =
    React.useState(initialState);

  const $onLoadPlan = async (e) => {
    const req = await Dispatch(ReceivingPlan.$show(e));

    if (req?.message === 'success') {
      setState((prevState) => ({...prevState, plan: req?.data}));
    }
  };

  const $handleSubmit = async () => {
    const payload = {
      plan_id: plan?.id,
      note: form?.note || '',
      ...items,
    };

    const req = await Dispatch(Receiving.$create(payload));

    if (req?.message === 'success') {
      History?.push(`/receiving/receive/${req?.data?.id}`);
    }
  };

  const $handleItemsChange = async (e) => {
    let items = []

    _.each(e?.items, function(i) {
      if (i?.quantity_received > 0 || i?.quantity_defect > 0) {
        items.push(i)
      }
    })

    setState((prevState) => ({ ...prevState, items: {items} }));
  };

  React.useEffect(() => {
    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }, 2000);
  }, []);

  React.useEffect(() => {
     if (!location?.state?.plan) {
        History.push('/receiving/plan');
    };
    $onLoadPlan(location?.state?.plan);
  }, [location?.state?.plan]);

  return (
    <Page type="form" className="col-md-6 bg-white" onSubmit={$handleSubmit}>
      <Page.Header title="Buat Receiving" />
      <Page.Body className="d-block px-3 py-3">
        <div className='row'>
            <div className='col-md-8 col-12'>
              <InformationPlan data={plan} />
            </div>
            <div className='col-md-4 col-12'>
              <FormInput isLoading={isLoading} onInputChange={(e) => setState((prevState) => ({ ...prevState, form: e }))}/>
            </div>
        </div>
        <FormItems plan={plan} onItemChange={$handleItemsChange}/>
      </Page.Body>
      <Page.Footer className="justify-content-center gap-2 pt-3 border-top mt-5 d-md-flex d-block mb-3 flex-wrap">
        <Button
          type="button"
          className="btn-secondary py-md-2"
          onClick={() => {
            History.replace(`/receiving/receive`);
          }}
        >
          Batal &amp; Kembali
        </Button>
        <Button
          type="submit"
          loading={StateForm?.loading}
          className="btn-primary py-md-2"
        >
          Simpan
        </Button>
      </Page.Footer>
    </Page>
  );
};

export default CreateScreen;
